import { useEffect } from "react";
import { FlexGrid, Typography, useThemeProvider, Card, Skeleton, Separator, Button } from '@albo-ui/core'
import DataTable from "react-data-table-component";
import { CustomerVipProps } from "./types";
import { useCompanyOnboardingTable } from "./hooks/useCompanyOnboardingTable";
import { useCompanyOnboardingManager } from "./hooks/useCompanyOnboardingManager";
import { customStyles2 } from "../../../util/TableStyles"
import { noDataComponent } from "../../../util/DataObject"
import { paginationComponentOptions } from "../../../util/i18n-es";
import CompanyInsertLink from "../../modals/company-onboarding-features";
import { ItemConfirmDialog } from "../../modals/confirm/ItemConfirmDialog";
import { IconButton, TextField, Tooltip, Switch } from "@mui/material";
import { Search, Refresh, ConnectWithoutContact } from "@mui/icons-material";

export const CompanyOnboardingList = ({ changeAlert, changeLoader, sectionData }: CustomerVipProps) => {
    const { theme } = useThemeProvider();
    const { loading: loadingUpdate, getCompanyList, handleGet, companyLinkCreate, companyUpdate, companyDelete } = useCompanyOnboardingManager(changeAlert)
    const { columns, data, row, title, loading: loadingTable, dialogProps, dialogConfirm, dialogText, filters, page, perPage, totalRows, statusSearch,
        saveData, getData, setRow, onOpenLinkAdd, changeValueSearch, companySearch, reset, handlePerRowsChange, handlePageChange, filterStatus } = useCompanyOnboardingTable(changeAlert, companyUpdate)

    const onCloseDialog = () => {
        setRow(null);
        dialogProps.onClose();
    };
    const onCloseDialogConfirm = () => {
        setRow(null);
        dialogConfirm.onClose();
    };
    const onCompanyLinkAdd = async (data: any) => {
        row ? companyUpdate(data) : companyLinkCreate(data);
        dialogProps.onClose();
        setRow(null);
    };
    const onCompanyLinkDelete = async () => {
        companyDelete({ company: { uuid: row["uuid"] } });
        dialogConfirm.onClose();
        setRow(null);
    };

    useEffect(() => {
        changeLoader(loadingTable);
        if (!loadingTable) {
            handleGet(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingTable]);

    useEffect(() => {
        saveData(sectionData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        changeLoader(loadingUpdate);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingUpdate]);
    useEffect(() => {
        if (getCompanyList) {
            getData(1, perPage, filters);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getCompanyList]);
    
    return (
        <Card padding={4} flexDirection="column" fullWidth fullHeight alignItems="stretch" justifyContent="space-between" style={{ borderColor: theme.colors.manatee }}> 
            <FlexGrid container fullWidth justify="space-between" style={{ margin: '25px 0' }}>
                <FlexGrid container fullWidth justify="space-between" style={{ display: "block" }}>
                    <FlexGrid item container direction="column">
                        <Typography variant="h2" style={{display: "inline-flex", alignItems: "center", fontSize: "1.2rem"}}>
                            <ConnectWithoutContact sx={{ marginRight: 1 }}/> Personalización de Links
                        </Typography>
                        <Typography variant="smallTitle">Onboarding Web</Typography>
                    </FlexGrid>
                </FlexGrid>

                <FlexGrid item container>
                    <Card width='75px' height='48px' alignItems='center' style={{padding: 0, marginRight: 20, alignSelf: "start", placeContent: "center", color: "#3743aa", border: "1px solid #3743aa" }}>
                        <Tooltip title={statusSearch === "enabled" ? "Mostrar inactivos" : "Mostrar activos"}>
                            <Switch onClick={filterStatus.bind(this)} checked={statusSearch === "enabled" ? true : false}/>
                        </Tooltip>
					</Card>
                    <Button onClick={onOpenLinkAdd.bind(this)} buttonType='secondary' size='normal' style={{width: 110}}>Agregar</Button>
                </FlexGrid>
            </FlexGrid>

            <FlexGrid container spacing={2} style={{width: 520, paddingTop: 15, paddingBottom: 25}}>
                <TextField
                    label={"ID"} value={filters["company_id"] || ""} color="secondary" size="small" fullWidth
                    onChange={changeValueSearch.bind(this, "company_id")}
                    InputProps={{endAdornment: (<IconButton onClick={companySearch.bind(this)} ><Search/></IconButton>)}}
                />
                <TextField
                    label={"Nombre"} value={filters["corporate_name"] || ""} color="secondary" size="small" fullWidth
                    onChange={changeValueSearch.bind(this, "corporate_name")}
                    InputProps={{endAdornment: (<IconButton onClick={companySearch.bind(this)} ><Search/></IconButton>)}}
                />
                <IconButton onClick={reset.bind(this)} sx={{padding: "0 !important"}} ><Refresh sx={{padding: "7px", borderRadius: 2, boxSizing: "content-box", color: "white", backgroundColor: "#8bc179" }}/></IconButton>
            </FlexGrid>
                    
            { data?.length === 0 && <Separator orientation="horizontal" style={{minHeight: 4, maxHeight: 4}} />}
            <FlexGrid container style={{margin: '25px 0' }} direction='column'>
                {
                    loadingTable ?
                        <Skeleton width="100%" height="100px" />
                        :
                        <DataTable
                            columns={columns}
                            data={data}
                            customStyles={customStyles2}
                            noDataComponent={noDataComponent}
                            progressPending={loadingTable}
                            pagination
                            paginationServer
                            paginationDefaultPage={page}
                            paginationPerPage={perPage}
                            paginationTotalRows={totalRows}
                            onChangeRowsPerPage={handlePerRowsChange}
                            onChangePage={handlePageChange}
                            paginationComponentOptions={paginationComponentOptions}
                        />
                }
            </FlexGrid>
            <CompanyInsertLink
                title={title}
                open={dialogProps.open}
                onClose={onCloseDialog}
                onConfirm={onCompanyLinkAdd.bind(this)}
                changeAlert={changeAlert}
                data={row}
            />
            <ItemConfirmDialog 
                open={dialogConfirm.open}
                title={dialogText["title"]}
                message={dialogText["message"]}
                onClose={onCloseDialogConfirm} 
                onConfirm={onCompanyLinkDelete.bind(this)} 
                item={row && row["corporate_name"]}
            />
        </Card>
    );
};
